module.exports = __webpack_public_path__ + "static/media/bi.c60d0e16.png";